// 9:管理者９が最高管理者
// role 4/5/6は「ユーザーRole再設計」(2026-05) で廃止。
// 廃止ラベルを残し、未移行ユーザーの識別を可能にする。
// role 7 = 「企業管理者（シーズン指定）」: 付与された SurveySeason のみ閲覧可能。
module.exports = {
  userRole: {
    0: '未設定',
    1: '受講者',
    2: 'リ・カレント管理者',
    3: '企業管理者(ALL)',
    4: '（廃止）企業管理者(E3)',
    5: '（廃止）企業管理者(360)',
    6: '（廃止）企業管理者(E3+360)',
    7: '企業管理者（シーズン指定）',
    8: 'その他',
    9: '特権管理者',
  },
};
